module.exports = __webpack_public_path__ + "static/img/KR.e19e9fcd.png";